import React, { useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import { SIDE } from '@/components/views/Resolution886/enums';
import { Side } from '../types';
import * as S from './styled';

interface HorizontalButtonsProps {
	children: JSX.Element;
	elementRef: React.MutableRefObject<HTMLDivElement | null>;
}

type HorizontalScroll = {
	step: number;
	speed: number;
	distance: number;
	element: HTMLDivElement | null;
};

const DEFAULT_SPEED = 10;
const DEFAULT_DISTANCE = 100;
const SIDE_LEFT_NUMBER = 10;
const SIDE_RIGHT_NUMBER = -10;

export function HorizontalButtons({ children, elementRef }: Readonly<HorizontalButtonsProps>): JSX.Element {
	const [arrowDisableLeft, setArrowDisableLeft] = useState<boolean>(true);
	const [arrowDisableRight, setArrowDisableRight] = useState<boolean>(false);

	function handleHorizontalScroll({ element, speed, distance, step }: Readonly<HorizontalScroll>) {
		if (!element) return;

		let scrollAmount = 0;

		const slideTimer = setInterval(() => {
			scrollAmount += moveElement(element, step);

			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}

			updateArrows(element);
		}, speed);
	}

	function moveElement(element: HTMLElement, step: number): number {
		element.scrollLeft += step;
		return Math.abs(step);
	}

	function updateArrows(element: HTMLElement): void {
		const isNotNumber = isNaN(Number(element.innerText.slice(-1)));
		const isAtStart = element.scrollLeft === 0;

		if (isNotNumber && !isAtStart) {
			setArrowDisableRight(true);
			setArrowDisableLeft(false);
			return;
		}

		if (isAtStart) {
			setArrowDisableRight(false);
			setArrowDisableLeft(true);
			return;
		}

		setArrowDisableRight(false);
		setArrowDisableLeft(false);
	}

	function handleOnClick(side: Side): void {
		const step = side === SIDE.RIGHT ? SIDE_LEFT_NUMBER : SIDE_RIGHT_NUMBER;
		handleHorizontalScroll({ element: elementRef.current, distance: DEFAULT_DISTANCE, speed: DEFAULT_SPEED, step });
	}

	function handleOnLeftClick(): void {
		handleOnClick(SIDE.LEFT);
	}

	function handleOnRightClick(): void {
		handleOnClick(SIDE.RIGHT);
	}

	return (
		<Row justify="center" align="bottom">
			<Col>
				<Button type="link" icon={<LeftOutlined />} disabled={arrowDisableLeft} onClick={handleOnLeftClick} />
			</Col>
			{!arrowDisableLeft && (
				<Col>
					<S.ShadowBar side={SIDE.LEFT} />
				</Col>
			)}
			{children}
			{!arrowDisableRight && (
				<Col>
					<S.ShadowBar side={SIDE.RIGHT} />
				</Col>
			)}
			<Col>
				<Button type="link" icon={<RightOutlined />} onClick={handleOnRightClick} />
			</Col>
		</Row>
	);
}
